import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=49858430"
import script from "./OrderType.vue?vue&type=script&lang=js"
export * from "./OrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports